import * as React from "react";
const SvgError = () => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.77 1.96a1 1 0 0 1 .707-.293h11.045a1 1 0 0 1 .707.292L30.04 9.77a1 1 0 0 1 .293.707v11.045a1 1 0 0 1-.293.707l-7.81 7.811a1 1 0 0 1-.708.293H10.477a1 1 0 0 1-.707-.293l-7.81-7.81a1 1 0 0 1-.293-.708V10.477a1 1 0 0 1 .292-.707zm1.122 1.707-7.225 7.225v10.216l7.225 7.225h10.216l7.225-7.225V10.892l-7.225-7.225z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.804 9.007a1 1 0 0 1 .987 1.104l-.745 7.157a1 1 0 0 1-.995.896h-.102a1 1 0 0 1-.995-.896l-.744-7.17a1 1 0 0 1 1.003-1.103z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16 23.273a1.212 1.212 0 1 0 0-2.425 1.212 1.212 0 0 0 0 2.425"
  }
));
export default SvgError;
